import React from "react";
import { Grid, Button } from "@mui/material";

export default function dowloadBT(props) {
  return (
    <Grid container alignItems="center" sx={{ margin: "10px" }}>
      <Button
        variant="outlined"
        style={{ color: "#84BD5A", borderColor: "#84BD5A" }}
        disabled={props.loading}
        onClick={props.onClick}
      >
        <span className="material-icons-outlined">description</span>
        Export
      </Button>
    </Grid>
  );
}
